import { NgModule } from '@angular/core';
import { LocalizedDatePipe } from './localized-date.pipe';
import { ShowImagePipe } from './show-image.pipe';
import { GetFileIconPipe } from './show-file-icon.pipe';
import { ArtstuffSharedLibsModule } from '../shared-libs.module';

const PIPES = [LocalizedDatePipe, ShowImagePipe, GetFileIconPipe];

@NgModule({
  imports: [ArtstuffSharedLibsModule],
  declarations: [...PIPES],
  exports: [...PIPES],
})
export class SharedPipeModule {}
